'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slick = void 0;
var $ = require("jquery");
require("slick-carousel");
var Slick = /** @class */ (function () {
    function Slick() {
        this.firstPlayFlag = true;
        this.spTabWidth = 1024;
        this.spWidth = 767;
        var key1 = '.bulletSlickGraduate';
        if ($(key1).length > 0) {
            $(key1).slick({
                autoplay: true,
                autoplaySpeed: 0,
                arrows: false,
                cssEase: 'linear',
                dots: false,
                speed: 8000,
                swipe: false,
                pauseOnFocus: false,
                pauseOnHover: false,
                centerMode: true,
                initialSlide: 3,
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            autoplaySpeed: 3000,
                            arrows: true,
                            dots: true,
                            fade: true,
                            centerMode: false,
                            initialSlide: 0,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            speed: 1000,
                            prevArrow: '<div class="myslick-arrow myslick-arrow--prev"><img src="/shared/img/common/icon_box_arrow.svg" alt="左矢印"></div>',
                            nextArrow: '<div class="myslick-arrow myslick-arrow--next"><img src="/shared/img/common/icon_box_arrow.svg" alt="右矢印"></div>',
                            variableWidth: false,
                        }
                    },
                ]
            });
        }
        var key2 = '.bulletSlickOpenCampus';
        if ($(key2).length > 0) {
            $(key2).slick({
                arrows: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                dots: true,
                fade: true,
                cssEase: 'linear',
                speed: 1000,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            autoplaySpeed: 3000,
                            arrows: false,
                            initialSlide: 0,
                        }
                    },
                ]
            });
        }
        var key3 = '.bulletSlickNewsImage';
        if ($(key3).length > 0) {
            $(key3).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: '.bulletSlickNewsNavi',
            });
            $('.bulletSlickNewsNavi').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                asNavFor: '.bulletSlickNewsImage',
                dots: true,
                // centerMode: true,
                focusOnSelect: true,
                // infinite: false,
                cssEase: 'linear',
                speed: 600,
            });
        }
        var key4 = '.bulletSlickOpenCampusEvent';
        if ($(key4).length > 0) {
            $(key4).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                fade: false,
                dots: true,
                autoplay: false,
                infinite: false,
                prevArrow: '<div class="my-slick-prev"><span class="pagination__box__arrow prev"></span><span class="pagination__box__text prev">back</span></div>',
                nextArrow: '<div class="my-slick-next"><span class="pagination__box__text next">next</span><span class="pagination__box__arrow next"></span></div>',
                // centerMode: false,
                // cssEase: 'linear',
                // speed: 600,
            });
        }
        // const key5 = '.bulletSlickGraduateNavi';
        // const key6 = '.bulletSlickGraduateSpecial';
        // if( $(key5).length > 0 ){
        //     $(key5).slick({
        //         asNavFor: '.bulletSlickGraduateSpecial',
        //         // autoplay: true,
        //         // autoplaySpeed: 0,
        //         arrows: false,
        //         cssEase: 'linear',
        //         dots: true,
        //         speed: 100,
        //         swipe: false,
        //         // pauseOnFocus: false, // フォーカスが合っても止めない
        //         // pauseOnHover: false, // hoverで止めるか
        //         centerMode: true,
        //         initialSlide: 3, // 最初に表示させる要素の番号を指定
        //         variableWidth: true, // スライドの要素の幅をcssで設定できるようにする
        //         responsive: [
        //             {
        //                 breakpoint: 1024,
        //                 settings: {
        //                     autoplaySpeed: 3000,
        //                     arrows: true,
        //                     dots: true,
        //                     fade: true,
        //                     centerMode: false,
        //                     initialSlide: 0,
        //                     slidesToShow: 1,
        //                     slidesToScroll: 1,
        //                     speed: 1000,
        //                     prevArrow: '<div class="myslick-arrow myslick-arrow--prev"><img src="/shared/img/common/icon_box_arrow.svg" alt="左矢印"></div>',
        //                     nextArrow: '<div class="myslick-arrow myslick-arrow--next"><img src="/shared/img/common/icon_box_arrow.svg" alt="右矢印"></div>',
        //                     variableWidth: false,
        //                 }
        //             },
        //         ],
        //     });
        //     $(key6).slick({
        //         slidesToShow: 1,
        //         slidesToScroll: 1,
        //         arrows: true,
        //         fade: false,
        //         dots: false,
        //         autoplay: false,
        //         infinite: false,
        //         prevArrow: '<div class="my-slick-prev"><span class="pagination__box__arrow prev"></span><span class="pagination__box__text prev">back</span></div>',
        //         nextArrow: '<div class="my-slick-next"><span class="pagination__box__text next">next</span><span class="pagination__box__arrow next"></span></div>',
        //     });
        // }
        // GRADUATE 交互にキャプションを上下に配置
        var target = $('.graduate__box');
        $('.slick-slide:nth-of-type(odd)').find(target).attr('data-position', 'bottom');
        $('.slick-slide:nth-of-type(even)').find(target).attr('data-position', 'top');
    }
    return Slick;
}());
exports.Slick = Slick;
exports.default = Slick;
